// NotFound.jsx - 404 Error Page with Galaxy Theme
import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../../assets/css/general/notfound/NotFound.css';

const NotFound = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
    // Or use: window.location.href = '/';
  };

  return (
    <div className="notfound-container">
      {/* Animated Stars Background */}
      <div className="stars-background">
        <div className="stars"></div>
        <div className="stars2"></div>
        <div className="stars3"></div>
      </div>

      {/* Main Content */}
      <div className="notfound-content">
        
        {/* Galaxy Text "oops!" */}
        <h1 className="galaxy-text">oops!</h1>
        
        {/* Error Code and Message */}
        <div className="error-info">
          <h2 className="error-code">404 - PAGE NOT FOUND</h2>
          <p className="error-message">
            The page you are looking for might have been removed<br />
            had its name changed or is temporarily unavailable.
          </p>
        </div>

        {/* Call to Action Button */}
        <button 
          className="home-button"
          onClick={handleGoHome}
          aria-label="Go to homepage"
        >
          GO TO HOMEPAGE
        </button>
      </div>
    </div>
  );
};

export default NotFound;